import { CheckIndexedDBIsSupport } from "@/IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import { BroadcastReCreateTab, SetUserChannel } from "@/broadcastChannel/userChannel";
import {
  ActivityLogSource,
  ApplipcationStoreType,
  HttpStatusCode,
  LoadingStatusType,
  Locales,
  TypeComponentNoti,
  UserType,
} from "@/enums/enums";
import {
  CompareMerchantNameEn,
  CompareMerchantNameTh,
  ConvertToMerchantList,
  GetSelectedMerchant,
} from "@/helper/merchantHelper";
import { SocketConnect } from "@/helper/notificationHelper";
import { GetErrorMessageByExceptionCode } from "@/helper/shareHelper";
import { ClearTabFromLocalStorage, InsertTabIdToTabDB, UpdateTabMerchantId } from "@/helper/tabHelper";
import {
  MerchantId,
  RefreshToken,
  RemoveCookiesToken,
  SetCookiesAccessToken,
  SetCookiesKeepLogin,
  SetCookiesRefreshToken,
} from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { UserModel } from "@/model/user/userModel";
import router from "@/router/index";
import API from "@/service/Index";
import { DatadogRumService } from "@/service/datadog/datadogRumService";
import { ConvertToUserModel } from "@/service/user/authenFacade";
import { ConvertToUserDetailList } from "@/service/user/userFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import TextHelper from "../../helper/textHelper";

@Module({ namespaced: true })
class LogIn extends VuexModule {
  public loginLoadingStatus = LoadingStatusType.None;
  public userModel: UserModel | null = null;
  public merchantList = [] as Array<MerchantInFoModel>;
  public merchantListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public selectMerchant: SelectedMerchantModel | null = null;
  public setSelectMerchantLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public otherUserList = [] as Array<any>;
  public otherUserListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public userInfoByUserIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public refreshTokenExpirationLodingStatus: LoadingStatusType = LoadingStatusType.None;
  public merchantModelByIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public merchantModelListForMap: Map<number, SelectedMerchantModel> = new Map();
  public favoriteMerchantList: any = [];
  public favoriteMerchantListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateFavoriteMerchantLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public deleteFavoriteMerchantLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getLoginLoadingStatus(): LoadingStatusType {
    return this.loginLoadingStatus;
  }
  get getMerchantList(): Array<MerchantInFoModel> {
    const merchantListMockup = [...this.merchantList];
    if (i18n.locale == Locales.TH) {
      return merchantListMockup.sort(CompareMerchantNameTh);
    } else {
      return merchantListMockup.sort(CompareMerchantNameEn);
    }
  }
  get getMerchantListLoadingStatus(): LoadingStatusType {
    return this.merchantListLoadingStatus;
  }
  get getUserModel(): UserModel | null {
    return this.userModel;
  }
  get getMerchant(): SelectedMerchantModel | null {
    return this.selectMerchant;
  }
  get getSetSelectMerchantLoadingStatus(): any {
    return this.setSelectMerchantLoadingStatus;
  }
  get getOtherUserList(): Array<any> {
    return this.otherUserList;
  }
  get getOtherUserListLoadingStatus(): LoadingStatusType {
    return this.otherUserListLoadingStatus;
  }
  get getUserInfoByUserIdLoadingStatus(): LoadingStatusType {
    return this.userInfoByUserIdLoadingStatus;
  }
  get getMerchantModelListForMap() {
    return this.merchantModelListForMap;
  }

  get getMerchantModelByIdLoadingStatus() {
    return this.merchantModelByIdLoadingStatus;
  }

  get getFavoriteMerchantList() {
    return this.favoriteMerchantList;
  }

  get getFavoriteMerchantListLoadingStatus() {
    return this.favoriteMerchantListLoadingStatus;
  }

  get getUpdateFavoriteMerchantLoadingStatus() {
    return this.updateFavoriteMerchantLoadingStatus;
  }

  get getDeleteFavoriteMerchantLoadingStatus() {
    return this.deleteFavoriteMerchantLoadingStatus;
  }

  @Mutation
  public MutationLoginLoadingStatus(status: LoadingStatusType): void {
    this.loginLoadingStatus = status;
  }

  @Mutation
  public MutationsSelectMerchant(_object: SelectedMerchantModel): void {
    this.selectMerchant = _object;
  }

  @Mutation
  public MutationsSetSelectMerchantLoadingStatus(status: LoadingStatusType): void {
    this.setSelectMerchantLoadingStatus = status;
  }

  @Mutation
  public MutationSetUserModel(userModel: UserModel) {
    this.userModel = userModel;
    sessionStorage.setItem("eui", userModel.userId.PeakEncryption());
  }

  @Mutation
  public MutationSetMerchantsList(merchantsList: Array<MerchantInFoModel>) {
    this.merchantList = merchantsList;
  }

  @Mutation
  public MutationSetMerchantListLoadingStatus(status: LoadingStatusType) {
    this.merchantListLoadingStatus = status;
  }

  @Mutation
  public MutationUserDetailForDisplay(otherUserList: any) {
    // this.otherUserList = otherUserList;
    if (!(this.otherUserList && this.otherUserList.length > 0)) {
      this.otherUserList = [];
    }
    for (const userDetail of otherUserList) {
      const otherUser = this.otherUserList.find((x) => x.userId === userDetail.userId);
      if (otherUser && otherUser.userId === userDetail.userDetail) {
        const index = this.otherUserList.indexOf(otherUser);
        this.otherUserList.splice(index, 1);
      }
      this.otherUserList.push(userDetail);
    }
  }

  @Mutation
  public MutationUserDetailForDisplayLoadingStatus(loadingStatus: LoadingStatusType) {
    this.otherUserListLoadingStatus = loadingStatus;
  }

  @Mutation
  public SetUserInfoByUserIdLoadingStatus(status: LoadingStatusType) {
    this.userInfoByUserIdLoadingStatus = status;
  }

  @Mutation
  public MutationsSetRefreshTokenExpirationLodingStatus(status: LoadingStatusType) {
    this.refreshTokenExpirationLodingStatus = status;
  }
  @Mutation
  MutationSetFavoriteMerchantList(favoriteMerchantList: any) {
    this.favoriteMerchantList = favoriteMerchantList;
  }

  @Mutation
  MutationSetFavoriteMerchantListLoadingStatus(status: LoadingStatusType) {
    this.favoriteMerchantListLoadingStatus = status;
  }

  @Mutation
  MutationSetUpdateFavoriteMerchantLoadingStatus(status: LoadingStatusType) {
    this.updateFavoriteMerchantLoadingStatus = status;
  }

  @Mutation
  MutationSetDeleteFavoriteMerchantLoadingStatus(status: LoadingStatusType) {
    this.deleteFavoriteMerchantLoadingStatus = status;
  }

  @Mutation
  public MutationSetMerchantModelByIdLoadingStatus(status: LoadingStatusType) {
    this.merchantModelByIdLoadingStatus = status;
  }

  @Mutation
  MutationSetMerchantModelList(merchantModel: SelectedMerchantModel) {
    this.merchantModelListForMap.set(merchantModel.merchantId, merchantModel);
  }

  @Action
  public cleanLogin() {
    return API.AuthenService.DoGetNewAccessTokenByRefreshToken().then((res) => {
      if (res.status.IsSuccess()) {
        const idToken = res.data.id_token;
        const userId: any = this.userModel?.userId.PeakEncryption();
        return API.AuthenService.DoRevokeToken(idToken, userId).then((resRevokeToken) => {
          this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
          RemoveCookiesToken();
          sessionStorage.removeItem("emi");
          return resRevokeToken;
        });
      } else {
        this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
        RemoveCookiesToken();
        sessionStorage.removeItem("emi");
        return res;
      }
    });
  }

  @Action
  public DoLogIn(_input: any): void {
    this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Loading);
    let encpw: string = _input.password;

    if (_input.userType == UserType.Email) {
      encpw = TextHelper.CreateToken(_input.password);
    }

    const requestInput = {
      userName: _input.username,
      password: encpw,
      userType: _input.userType,
    };
    const source = ActivityLogSource.PeakTax;
    API.AuthenService.DoGetAccessToken(requestInput, source).then((resAccessToken) => {
      if (resAccessToken.status.IsSuccess()) {
        const responseCode = resAccessToken.data.response_code ? resAccessToken.data.response_code : 200;

        if (responseCode.IsSuccess()) {
          const token = {
            accessToken: resAccessToken.data.access_token,
            refreshToken: resAccessToken.data.refresh_token,
          };

          if (_input.keepLogin) {
            SetCookiesKeepLogin();
            SetCookiesAccessToken(token.accessToken);
            SetCookiesRefreshToken(token.refreshToken, true);
          } else {
            SetCookiesAccessToken(token.accessToken);
            SetCookiesRefreshToken(token.refreshToken);
          }

          API.AuthenService.DoGetUserInfo().then(async (resUserInfo) => {
            if (resUserInfo.status.IsSuccess()) {
              DatadogRumService.SetUserFromUserInfo(resUserInfo?.data?.userInfo);
              const userModel = ConvertToUserModel(resUserInfo.data.userInfo);
              this.context.commit("MutationSetUserModel", userModel);
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
              ClearTabFromLocalStorage();
              if (_input.register) {
                router.push({ name: "welcome" });
              } else {
                const lastUrl = localStorage.getItem("lastUrlPeakTax");
                if (lastUrl) {
                  localStorage.removeItem("lastUrlPeakTax");
                  window.location.href = lastUrl;
                } else {
                  if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                    await InsertTabIdToTabDB();
                    SetUserChannel(userModel.userId);
                    BroadcastReCreateTab();
                  }
                  SocketConnect();
                  router.push({ name: "selectList" });
                }
              }
            } else {
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
              router.push("/logout");
            }
          });
        } else {
          let loginStatus = LoadingStatusType.Fail;

          if (_input.userType === UserType.Google && responseCode === HttpStatusCode.Moved) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Alert_Login_Google_Fail"),
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
            router.push({ name: "register" });
            loginStatus = LoadingStatusType.None;
          }
          this.context.commit("MutationLoginLoadingStatus", loginStatus);
          RemoveCookiesToken();
        }
      } else {
        this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Fail);
        RemoveCookiesToken();
      }
    });
  }

  @Action
  public AuthorizeModels(routerName: string) {
    const refreshToken = RefreshToken();
    if (refreshToken) {
      const userInfo: any = this.userModel;
      if (userInfo == null) {
        this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Loading);
        try {
          API.AuthenService.DoGetUserInfo().then(async (resUserInfo) => {
            if (resUserInfo.status.IsSuccess()) {
              DatadogRumService.SetUserFromUserInfo(resUserInfo?.data?.userInfo);
              const userModel = ConvertToUserModel(resUserInfo.data.userInfo);
              this.context.commit("MutationSetUserModel", userModel);
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
              ClearTabFromLocalStorage();
              if (routerName == "login") {
                router.push({ name: "selectList" });
              }
              ClearTabFromLocalStorage();
              if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
                await InsertTabIdToTabDB();
                SetUserChannel(userModel.userId);
              }
              SocketConnect();
            } else {
              this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
              router.push("/SessionExpire");
            }
          });
        } catch (err) {
          this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.None);
          router.push("/SessionExpire");
        }
      }
    } else {
      router.push("/logout");
    }
  }

  @Action
  DoRedirectByApplicationStore(applipcationStoreType: ApplipcationStoreType) {
    API.AuthenService.DoGetUserInfo().then((resAccess) => {
      if (resAccess.data.responseCode.IsSuccess()) {
        switch (applipcationStoreType) {
          case ApplipcationStoreType.Peak:
            window.open(`${process.env.VUE_APP_PeakEngine}home?emi=${MerchantId().PeakEncryption()}`);
            break;
          case ApplipcationStoreType.NewPeak:
            window.open(`${process.env.VUE_APP_PeakAccount}home?emi=${MerchantId().PeakEncryption()}`);

            break;
          case ApplipcationStoreType.Board:
            window.open(`${process.env.VUE_APP_PeakBoard}home?emi=${MerchantId().PeakEncryption()}`);

            break;
          case ApplipcationStoreType.Asset:
            window.open(`${process.env.VUE_APP_PeakAsset}home?emi=${MerchantId().PeakEncryption()}`);

            break;
          case ApplipcationStoreType.Payroll:
            window.open(`${process.env.VUE_APP_PeakPayroll}home?emi=${MerchantId().PeakEncryption()}`);

            break;
        }
      } else {
        router.push("/SessionExpire");
      }
    });
  }
  @Action
  public DoGetUserDetailForDisplay(userIdList: any) {
    if (this.otherUserListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUserDetailForDisplayLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoGetUserDetailForDisplay(userIdList).then((res) => {
        const userDetailList = ConvertToUserDetailList(res.data.userDetailList);
        this.context.commit("MutationUserDetailForDisplay", userDetailList);
        this.context.commit("MutationUserDetailForDisplayLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoRefreshMerchantList() {
    return API.UserService.DoRefreshMerchantList().then((res) => {
      if (res.status.IsSuccess()) {
        return true;
      } else {
        router.push("/SessionExpire");
        return false;
      }
    });
  }

  @Action
  public DoGetUserInfoByUserId() {
    if (this.userInfoByUserIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetUserInfoByUserIdLoadingStatus", LoadingStatusType.Loading);
      API.AuthenService.DoGetUserInfo().then((res) => {
        if (res.status.IsSuccess()) {
          const userModel = ConvertToUserModel(res.data.userInfo);
          this.context.commit("MutationSetUserModel", userModel);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetUserInfoByUserIdLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetMerchantList() {
    if (this.merchantListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetMerchantListLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetMerchantListByUserId().then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const merchantList = ConvertToMerchantList(res.data.merchantList);
          this.context.commit("MutationSetMerchantsList", merchantList);
        }
        this.context.commit("MutationSetMerchantListLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoSelectMerchant(input: any) {
    if (this.setSelectMerchantLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationsSetSelectMerchantLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetSelectedMerchant(input.merchantId).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          const selectMerchant = GetSelectedMerchant(res.data.merchant);
          if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
            UpdateTabMerchantId(selectMerchant?.merchantId);
          }
          this.context.commit("MutationsSelectMerchant", selectMerchant);
        } else {
          this.context.commit("MutationsSelectMerchant", null);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("MutationsSetSelectMerchantLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetRefreshTokenExpiration() {
    if (this.refreshTokenExpirationLodingStatus !== LoadingStatusType.Loading) {
      const refreshToken = RefreshToken();
      if (refreshToken) {
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("MutationsSetRefreshTokenExpirationLodingStatus", LoadingStatusType.Loading);
        API.AuthenService.DoGetRefreshTokenExpiration().then((res) => {
          if (res.status.IsSuccess()) {
            const lastUrl = localStorage.getItem("lastUrlPeakTax");
            if (lastUrl) {
              localStorage.removeItem("lastUrlPeakTax");
              window.location.href = lastUrl;
            } else {
              router.push({ name: "selectList" });
            }
          } else {
            RemoveCookiesToken();
          }
          this.context.dispatch("Loading/IsLoading", false, { root: true });
          this.context.commit("MutationsSetRefreshTokenExpirationLodingStatus", LoadingStatusType.Success);
        });
      } else {
        RemoveCookiesToken();
      }
    }
  }

  @Action
  public DoIntrospectAccessToken() {
    return new Promise((resolve) => {
      API.AuthenService.DoIntrospectAccessToken().then((res) => {
        if (res.status.IsSuccess()) {
          resolve(res.data.active);
        } else {
          resolve(false);
        }
      });
    });
  }
  @Action
  DoGetFavoriteMerchant() {
    if (this.favoriteMerchantListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.Loading);

      API.MerchantService.DoGetFavoriteMerchant().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetFavoriteMerchantList", res.data.merchantFavorite);
        } else {
          const alertMessage = GetErrorMessageByExceptionCode(res.data.exception);

          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  DoUpdateFavoriteMerchant(merchantId: number) {
    if (this.updateFavoriteMerchantLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetUpdateFavoriteMerchantLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoUpdateFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSetUpdateFavoriteMerchantLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  DoDeleteFavoriteMerchant(merchantId: number) {
    if (this.deleteFavoriteMerchantLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetDeleteFavoriteMerchantLoadingStatus", LoadingStatusType.Loading);

      API.MerchantService.DoDeleteFavoriteMerchant(merchantId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetFavoriteMerchantListLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("MutationSetDeleteFavoriteMerchantLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  DoGetMerchantModelById(merchantId: number) {
    return new Promise((resolve) => {
      this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Loading);

      const merchantModelOnLocal = this.merchantModelListForMap.get(merchantId) ?? null;

      if (merchantModelOnLocal) {
        setTimeout(() => {
          this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Success);
          resolve(merchantModelOnLocal);
        }, 0);
      } else {
        API.MerchantService.DoGetSelectedMerchant(merchantId).then((res: any) => {
          if (res.status.IsSuccess() || res.data.responseCode.IsSuccess()) {
            const merchant = GetSelectedMerchant(res.data.merchant);
            this.context.commit("MutationSetMerchantModelList", merchant);
            this.context.commit("MutationSetMerchantModelByIdLoadingStatus", LoadingStatusType.Success);
            resolve(merchant);
          }
        });
      }
    });
  }
}

export default LogIn;
